import React from "react";
import { FaTwitter, FaInstagram, FaGithub, FaArrowDown } from "react-icons/fa";
import { Link } from "react-scroll";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__bg">
        <div className="hero__orb hero__orb--1"></div>
        <div className="hero__orb hero__orb--2"></div>
        <div className="hero__orb hero__orb--3"></div>
      </div>

      <div className="hero__content">
        <span className="hero__greeting">Hi there, I'm</span>
        <h1 className="hero__name">Alex Rodriguez</h1>
        <h2 className="hero__title">Software Developer</h2>
        <p className="hero__location">
          <span className="hero__dot"></span>
          Augsburg, Germany
        </p>
        <p className="hero__desc">
          Building scalable, enterprise-grade web applications at CHECK24.<br />
          Passionate about clean code, modern architectures, and great UX.
        </p>
        <div className="hero__actions">
          <Link
            to="contact"
            smooth={true}
            duration={600}
            className="hero__btn hero__btn--primary"
          >
            Get in touch
          </Link>
          <Link
            to="resume"
            smooth={true}
            duration={600}
            className="hero__btn hero__btn--outline"
          >
            View Resume
          </Link>
        </div>
        <div className="hero__socials">
          <a
            href="https://twitter.com/alexbyrod"
            aria-label="Twitter"
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.instagram.com/alexbyrod_7"
            aria-label="Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://github.com/Sterki"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
        </div>
      </div>

      <div className="hero__scroll">
        <Link to="about" smooth={true} duration={600}>
          <span>Scroll down</span>
          <FaArrowDown />
        </Link>
      </div>
    </section>
  );
}
